import {LensesAction, LensesActionType} from './lenses.action';
import {LensesState, initialLensesState} from './lenses.state';

export function lensesReducer(state: LensesState = initialLensesState, action: LensesAction): LensesState {
  switch (action.type) {
    case LensesActionType.GET_SUCCESS:
      return {...state, lenses: action.payload.lenses};
    case LensesActionType.GET_SINGLE_SUCCESS:
      return {...state, lens: action.payload.lens};
    case LensesActionType.CLEAR_SINGLE:
      return {...state, lens: null};
    case LensesActionType.GET_USER_LENS_SUCCESS:
      return {...state, userLens: action.payload.userLens};
    case LensesActionType.CLEAR:
      return {
        lenses: [],
        lens: null,
        userLens: null,
      };
    default:
      return state;
  }
}
